export default "__VITE_ASSET__b109b675__"